import type { TimeRange } from '../../services/analyticsService'

export type AnalyticsMode = 'overview' | 'live' | 'breakdowns' | 'explore' | 'setup'

export const TIME_RANGES: TimeRange[] = ['24h', '48h', '72h', '5d', '15d', '30d', '60d', '90d']

export const TIME_RANGE_LABELS: Record<TimeRange, string> = {
  '24h': 'Last 24h',
  '48h': 'Last 48h',
  '72h': 'Last 72h',
  '5d': 'Last 5d',
  '15d': 'Last 15d',
  '30d': 'Last 30d',
  '60d': 'Last 60d',
  '90d': 'Last 90d',
}

export function formatCompactNumber(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return '—'
  return new Intl.NumberFormat(undefined, {
    notation: Math.abs(value) >= 10_000 ? 'compact' : 'standard',
    maximumFractionDigits: 1,
  }).format(value)
}

export function calcDelta(current: number, prior: number): { label: string; positive: boolean } | null {
  if (!Number.isFinite(current) || !Number.isFinite(prior) || prior === 0) return null
  const pct = ((current - prior) / prior) * 100
  return {
    label: `${pct >= 0 ? '+' : ''}${pct.toFixed(0)}%`,
    positive: pct >= 0,
  }
}
